export const serviceTypes = [
  'Level Container',
  'Refrigerated Rental Repair',
  'Refrigerated Sale Repair',
  'Refrigerated Maintenance',
  'Container Repair',
  'Modification Repair',
  'Reposition'
]
